import { StockIndicatorHelpers } from "@grandvisionhq/inventory";
const shouldShowBackInStockNotification = (variant, thresholds) => {
  if (variant.__typename === "FrameVariant" || variant.__typename === "SunglassesVariant") {
    const { channelAvailability } = variant.variantTypeDetails;
    const stockLabel = StockIndicatorHelpers.stockResolver(
      channelAvailability,
      !!variant.isAllowBackOrder,
      variant.inventory?.totalQuantity || 0,
      thresholds
    )?.labelId;
    return !variant.isExcludedFromCheckout && stockLabel === "outOfStock" && !!variant.inventory?.items[0]?.allowBackInStockNotification;
  }
  return false;
};
export {
  shouldShowBackInStockNotification
};
//# sourceMappingURL=should-show-back-in-stock-notification.js.map
